import React from 'react';
import PropTypes from 'prop-types';

const Phone = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 23">
      <g fillRule="evenodd" transform="translate(-1 0)">
        <path
          id="a"
          d="M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
        />
      </g>
    </svg>
  );
};

Phone.propTypes = {
  className: PropTypes.string,
};
export default Phone;
